/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CsrfTokenResponse
 */
export interface CsrfTokenResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CsrfTokenResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CsrfTokenResponse
     */
    token?: string;
    /**
     * 
     * @type {string}
     * @memberof CsrfTokenResponse
     */
    headerName?: string;
    /**
     * 
     * @type {string}
     * @memberof CsrfTokenResponse
     */
    parameterName?: string;
    /**
     * 
     * @type {string}
     * @memberof CsrfTokenResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the CsrfTokenResponse interface.
 */
export function instanceOfCsrfTokenResponse(value: object): value is CsrfTokenResponse {
    return true;
}

export function CsrfTokenResponseFromJSON(json: any): CsrfTokenResponse {
    return CsrfTokenResponseFromJSONTyped(json, false);
}

export function CsrfTokenResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CsrfTokenResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'token': json['token'] == null ? undefined : json['token'],
        'headerName': json['headerName'] == null ? undefined : json['headerName'],
        'parameterName': json['parameterName'] == null ? undefined : json['parameterName'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function CsrfTokenResponseToJSON(json: any): CsrfTokenResponse {
    return CsrfTokenResponseToJSONTyped(json, false);
}

export function CsrfTokenResponseToJSONTyped(value?: CsrfTokenResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'token': value['token'],
        'headerName': value['headerName'],
        'parameterName': value['parameterName'],
        'error': value['error'],
    };
}

